import { GridRowSelectionModel } from "@mui/x-data-grid";
import { Box } from "@mui/material";
import { CancelSelectedSessions } from "./CancelSelectedSessions";
import { SelectAllFutureSessions } from "./SelectAllFutureSessions";

type SessionsActionButtonsProps = {
    selectedRows: Array<number>;
    setSelectedRows: (rows: GridRowSelectionModel) => void;
    items: Array<any>;
};

export const SessionsActionButtons = ({ selectedRows, setSelectedRows, items }: SessionsActionButtonsProps) => {
    return (
        <Box
            sx={{
                position: "absolute",
                bottom: 100,
                right: 100,
                display: "flex",
                gap: 2,
                alignItems: "center",
            }}
        >
            <SelectAllFutureSessions selectedRows={selectedRows} setSelectedRows={setSelectedRows} items={items} />
            <CancelSelectedSessions selectedRows={selectedRows} setSelectedRows={setSelectedRows} items={items} />
        </Box>
    );
};
